var _classCallCheck = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var debug = require('debug')('bittorrent-tracker:client');

var EventEmitter = require('events');

var once = require('once');

var parallel = require('run-parallel');

var Peer = require('simple-peer');

var common = require('./lib/common');

var HTTPTracker = require('./lib/client/http-tracker'); // empty object in browser


var UDPTracker = require('./lib/client/udp-tracker'); // empty object in browser


var WebSocketTracker = require('./lib/client/websocket-tracker');
/**
 * BitTorrent tracker client.
 *
 * Find torrent peers, to help a torrent client participate in a torrent swarm.
 *
 * @param {Object} opts                          options object
 * @param {string|Buffer} opts.infoHash          torrent info hash
 * @param {string|Buffer} opts.peerId            peer id
 * @param {string|Array.<string>} opts.announce  announce
 * @param {number} opts.port                     torrent client listening port
 * @param {function} opts.getAnnounceOpts        callback to provide data to tracker
 * @param {number} opts.rtcConfig                RTCPeerConnection configuration object
 * @param {number} opts.userAgent                User-Agent header for http requests
 * @param {number} opts.wrtc                     custom webrtc impl (useful in node.js)
 */


var Client = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(Client, _EventEmitter);

  var _super = _createSuper(Client);

  function Client() {
    var _this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Client);

    _this = _super.call(this);
    if (!opts.peerId) throw new Error('Option `peerId` is required');
    if (!opts.infoHash) throw new Error('Option `infoHash` is required');
    if (!opts.announce) throw new Error('Option `announce` is required');
    if (!process.browser && !opts.port) throw new Error('Option `port` is required');
    _this.peerId = typeof opts.peerId === 'string' ? opts.peerId : opts.peerId.toString('hex');
    _this._peerIdBuffer = Buffer.from(_this.peerId, 'hex');
    _this._peerIdBinary = _this._peerIdBuffer.toString('binary');
    _this.infoHash = typeof opts.infoHash === 'string' ? opts.infoHash.toLowerCase() : opts.infoHash.toString('hex');
    _this._infoHashBuffer = Buffer.from(_this.infoHash, 'hex');
    _this._infoHashBinary = _this._infoHashBuffer.toString('binary');
    debug('new client %s', _this.infoHash);
    _this.destroyed = false;
    _this._port = opts.port;
    _this._getAnnounceOpts = opts.getAnnounceOpts;
    _this._rtcConfig = opts.rtcConfig;
    _this._userAgent = opts.userAgent; // Support lazy 'wrtc' module initialization
    // See: https://github.com/webtorrent/webtorrent-hybrid/issues/46

    _this._wrtc = typeof opts.wrtc === 'function' ? opts.wrtc() : opts.wrtc;
    var announce = typeof opts.announce === 'string' ? [opts.announce] : opts.announce == null ? [] : opts.announce; // Remove trailing slash from trackers to catch duplicates

    announce = announce.map(function (announceUrl) {
      announceUrl = announceUrl.toString();

      if (announceUrl[announceUrl.length - 1] === '/') {
        announceUrl = announceUrl.substring(0, announceUrl.length - 1);
      }

      return announceUrl;
    }); // remove duplicates by converting to Set and back

    announce = Array.from(new Set(announce));
    var webrtcSupport = _this._wrtc !== false && (!!_this._wrtc || Peer.WEBRTC_SUPPORT);

    var nextTickWarn = function nextTickWarn(err) {
      process.nextTick(function () {
        _this.emit('warning', err);
      });
    };

    _this._trackers = announce.map(function (announceUrl) {
      var parsedUrl;

      try {
        parsedUrl = new URL(announceUrl);
      } catch (err) {
        nextTickWarn(new Error("Invalid tracker URL: ".concat(announceUrl)));
        return null;
      }

      var port = parsedUrl.port;

      if (port < 0 || port > 65535) {
        nextTickWarn(new Error("Invalid tracker port: ".concat(announceUrl)));
        return null;
      }

      var protocol = parsedUrl.protocol;

      if ((protocol === 'http:' || protocol === 'https:') && typeof HTTPTracker === 'function') {
        return new HTTPTracker(_assertThisInitialized(_this), announceUrl);
      } else if (protocol === 'udp:' && typeof UDPTracker === 'function') {
        return new UDPTracker(_assertThisInitialized(_this), announceUrl);
      } else if ((protocol === 'ws:' || protocol === 'wss:') && webrtcSupport) {
        // Skip ws:// trackers on https:// sites because they throw SecurityError
        if (protocol === 'ws:' && typeof window !== 'undefined' && window.location.protocol === 'https:') {
          nextTickWarn(new Error("Unsupported tracker protocol: ".concat(announceUrl)));
          return null;
        }

        return new WebSocketTracker(_assertThisInitialized(_this), announceUrl);
      } else {
        nextTickWarn(new Error("Unsupported tracker protocol: ".concat(announceUrl)));
        return null;
      }
    }).filter(Boolean);
    return _this;
  }
  /**
   * Send a `start` announce to the trackers.
   * @param {Object} opts
   * @param {number=} opts.uploaded
   * @param {number=} opts.downloaded
   * @param {number=} opts.left (if not set, calculated automatically)
   */


  _createClass(Client, [{
    key: "start",
    value: function start(opts) {
      opts = this._defaultAnnounceOpts(opts);
      opts.event = 'started';
      debug('send `start` %o', opts);

      this._announce(opts); // start announcing on intervals


      this._trackers.forEach(function (tracker) {
        tracker.setInterval();
      });
    }
    /**
     * Send a `stop` announce to the trackers.
     * @param {Object} opts
     * @param {number=} opts.uploaded
     * @param {number=} opts.downloaded
     * @param {number=} opts.numwant
     * @param {number=} opts.left (if not set, calculated automatically)
     */

  }, {
    key: "stop",
    value: function stop(opts) {
      opts = this._defaultAnnounceOpts(opts);
      opts.event = 'stopped';
      debug('send `stop` %o', opts);

      this._announce(opts);
    }
    /**
     * Send a `complete` announce to the trackers.
     * @param {Object} opts
     * @param {number=} opts.uploaded
     * @param {number=} opts.downloaded
     * @param {number=} opts.numwant
     * @param {number=} opts.left (if not set, calculated automatically)
     */

  }, {
    key: "complete",
    value: function complete(opts) {
      if (!opts) opts = {};
      opts = this._defaultAnnounceOpts(opts);
      opts.event = 'completed';
      debug('send `complete` %o', opts);

      this._announce(opts);
    }
    /**
     * Send a `update` announce to the trackers.
     * @param {Object} opts
     * @param {number=} opts.uploaded
     * @param {number=} opts.downloaded
     * @param {number=} opts.numwant
     * @param {number=} opts.left (if not set, calculated automatically)
     */

  }, {
    key: "update",
    value: function update(opts) {
      opts = this._defaultAnnounceOpts(opts);
      if (opts.event) delete opts.event;
      debug('send `update` %o', opts);

      this._announce(opts);
    }
  }, {
    key: "_announce",
    value: function _announce(opts) {
      this._trackers.forEach(function (tracker) {
        // tracker should not modify `opts` object, it's passed to all trackers
        tracker.announce(opts);
      });
    }
    /**
     * Send a scrape request to the trackers.
     * @param {Object} opts
     */

  }, {
    key: "scrape",
    value: function scrape(opts) {
      debug('send `scrape`');
      if (!opts) opts = {};

      this._trackers.forEach(function (tracker) {
        // tracker should not modify `opts` object, it's passed to all trackers
        tracker.scrape(opts);
      });
    }
  }, {
    key: "setInterval",
    value: function setInterval(intervalMs) {
      debug('setInterval %d', intervalMs);

      this._trackers.forEach(function (tracker) {
        tracker.setInterval(intervalMs);
      });
    }
  }, {
    key: "destroy",
    value: function destroy(cb) {
      if (this.destroyed) return;
      this.destroyed = true;
      debug('destroy');

      var tasks = this._trackers.map(function (tracker) {
        return function (cb) {
          tracker.destroy(cb);
        };
      });

      parallel(tasks, cb);
      this._trackers = [];
      this._getAnnounceOpts = null;
    }
  }, {
    key: "_defaultAnnounceOpts",
    value: function _defaultAnnounceOpts() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (opts.numwant == null) opts.numwant = common.DEFAULT_ANNOUNCE_PEERS;
      if (opts.uploaded == null) opts.uploaded = 0;
      if (opts.downloaded == null) opts.downloaded = 0;
      if (this._getAnnounceOpts) opts = Object.assign({}, opts, this._getAnnounceOpts());
      return opts;
    }
  }]);

  return Client;
}(EventEmitter);
/**
 * Simple convenience function to scrape a tracker for an info hash without needing to
 * create a Client, pass it a parsed torrent, etc. Support scraping a tracker for multiple
 * torrents at the same time.
 * @params {Object} opts
 * @param  {string|Array.<string>} opts.infoHash
 * @param  {string} opts.announce
 * @param  {function} cb
 */


Client.scrape = function (opts, cb) {
  cb = once(cb);
  if (!opts.infoHash) throw new Error('Option `infoHash` is required');
  if (!opts.announce) throw new Error('Option `announce` is required');
  var clientOpts = Object.assign({}, opts, {
    infoHash: Array.isArray(opts.infoHash) ? opts.infoHash[0] : opts.infoHash,
    peerId: Buffer.from('01234567890123456789'),
    // dummy value
    port: 6881 // dummy value

  });
  var client = new Client(clientOpts);
  client.once('error', cb);
  client.once('warning', cb);
  var len = Array.isArray(opts.infoHash) ? opts.infoHash.length : 1;
  var results = {};
  client.on('scrape', function (data) {
    len -= 1;
    results[data.infoHash] = data;

    if (len === 0) {
      client.destroy();
      var keys = Object.keys(results);

      if (keys.length === 1) {
        cb(null, results[keys[0]]);
      } else {
        cb(null, results);
      }
    }
  });
  opts.infoHash = Array.isArray(opts.infoHash) ? opts.infoHash.map(function (infoHash) {
    return Buffer.from(infoHash, 'hex');
  }) : Buffer.from(opts.infoHash, 'hex');
  client.scrape({
    infoHash: opts.infoHash
  });
  return client;
};

module.exports = Client;